import API_PATH from "../../constants/config.json";
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

export const getMidblockStationRecentYear = async (station_id) => {
    try {
      return axios({
        method: 'post',
        url: API_URL + API_PATH.getStationRecentYear,
        data: {
          stationId: station_id
        }
      }).then(function (response) {              
        if (response && response.data.data) {          
          return response.data.data;
        } else {
            return []
        }
      })
    }
    catch (error) {
        return []
    }
  }
  export const getMidblockSummaryData = async (station_id) => {
    try {
      return axios({
        method: 'post',
        url: API_URL + API_PATH.getMidblockSummary,
        data: {
          stationId: station_id
        }
      }).then(function (response) {              
        if (response && response.data.data) {          
          return response.data.data
        } else {
          return []
        }
      })
    }
    catch (error) {
      return []
    }
  }
  function findLineByLeastSquares(values_x, values_y) {
    var x_sum = 0;
    var y_sum = 0;
    var xy_sum = 0;
    var xx_sum = 0;
    var count = 0;

    /*
     * The above is just for quick access, makes the program faster
     */
    var x = 0;
    var y = 0;
    var values_length = values_x.length;

    if (values_length != values_y.length) {
      throw new Error('The parameters values_x and values_y need to have same size!');
    }

    /*
     * Above and below cover edge cases
     */
    if (values_length === 0) {
      return [[], []];
    }

    /*
     * Calculate the sum for each of the parts necessary.
     */
    for (let i = 0; i < values_length; i++) {
      x = values_x[i];
      y = values_y[i];
      x_sum += x;
      y_sum += y;
      xx_sum += x * x;
      xy_sum += x * y;
      count++;
    }

    /*
     * Calculate m and b for the line equation:
     * y = x * m + b
     */
    var m = (count * xy_sum - x_sum * y_sum) / (count * xx_sum - x_sum * x_sum);
    var b = (y_sum / count) - (m * x_sum) / count;

    /*
     * We then return the x and y data points according to our fit
     */
    var result_values_x = [];
    var result_values_y = [];

    var totalRsult = [];

    for (let i = 0; i < values_length; i++) {
      x = values_x[i];
      y = x * m + b;
      result_values_x.push(x);
      result_values_y.push(y);

      totalRsult.push([x, y]);
    }

    return totalRsult;

  }  
  //This function is used for regression ... Start
const regression = (x, y, typ) => {
var type = (typ == null) ? 'linear' : typ;
var N = x.length;
var slope;
var intercept;
var SX = 0;
var SY = 0;
var SXX = 0;
var SXY = 0;
var SYY = 0;
var Y = [];
var X = [];

if (type == 'linear') {
  X = x;
  Y = y;
}
else if (type == 'exp' || type == 'exponential') {
  for (var i = 0; i < y.length; i++) {
    if (y[i] <= 0) {
      N--;
    }
    else {
      X.push(x[i]);
      Y.push(Math.log(y[i]));
    }
  }
}

for (var i = 0; i < N; i++) {
  SX = SX + X[i];
  SY = SY + Y[i];
  SXY = SXY + X[i] * Y[i];
  SXX = SXX + X[i] * X[i];
  SYY = SYY + Y[i] * Y[i];
}

slope = (N * SXY - SX * SY) / (N * SXX - SX * SX);
intercept = (SY - slope * SX) / N;

return [slope, intercept];
}
//This function is used for regression ... End

//This function is used for linear expression ... Start
const linearRegression = (X, Y) => {
var ret;
ret = regression(X, Y, 'linear');
return [ret[0], ret[1]];
}
//This function is used for linear expression ... End


//This function is used for regular expression ... Start
const expRegression = (X, Y) => {
var ret;
var x = X;
var y = Y;
ret = regression(x, y, 'exp');
var base = Math.exp(ret[0]);
var coeff = Math.exp(ret[1]);
return [base, coeff];
}
//This function is used for regular expression ... End


//This function is used for fit Data ... Start
const fitData = (data, typ) => {
var type = 'linear';
var ret;
var res;
var x = [];
var y = [];
var ypred = [];

for (i = 0; i < data.length; i++) {
  if (data[i] != null && Object.prototype.toString.call(data[i]) === '[object Array]') {
    if (data[i] != null && data[i][0] != null && data[i][1] != null) {
      x.push(data[i][0]);
      y.push(data[i][1]);
    }
  }
  else if (data[i] != null && typeof data[i] === 'number') {//If type of X axis is category
    x.push(i);
    y.push(data[i]);
  }
  else if (data[i] != null && Object.prototype.toString.call(data[i]) === '[object Object]') {
    if (data[i] != null && data[i].x != null && data[i].y != null) {
      x.push(data[i].x);
      y.push(data[i].y);
    }
  }
}

if (type == 'linear') {

  ret = linearRegression(x, y);
  for (var i = 0; i < x.length; i++) {
    res = ret[0] * x[i] + ret[1];
    ypred.push([x[i], res]);
  }

  return {
    data: ypred,
    slope: ret[0],
    intercept: ret[1],
    y: function (x) {
      return (this.slope * x) + this.intercept;
    },
    x: function (y) {
      return (y - this.intercept) / this.slope;
    }
  };
}
else if (type == 'exp' || type == 'exponential') {

  ret = expRegression(x, y);
  for (var i = 0; i < x.length; i++) {
    res = ret[1] * Math.pow(ret[0], x[i]);
    ypred.push([x[i], res]);
  }
  ypred.sort();

  return {
    data: ypred,
    base: ret[0],
    coeff: ret[1]
  };
}
}
export const getMidblockADTeChart = async (station_id) => {
    try {
      return axios({
        method: 'post',
        url: API_URL + API_PATH.getADT,
        data: {
          stationId: station_id,
        }
      }).then(function (response) {
        if (response && response.data.data) {
          let result = {};
          let ADTData = [];
          let ADTYear = [];

          let datas = [];

          //seteChartGet(response.data.data.length);
          result['eChartGet'] = response.data.data.length;
          for (let i = 0; i < response.data.data.length; i++) {

            let adt = parseInt(response.data.data[i].adt.replace(/,/g, ''));
            let adtHover = response.data.data[i].adt;
            let year = parseInt(response.data.data[i].cnt_year);

            datas.push([year, adt, adtHover]);

            ADTData.push(adt);
            ADTYear.push(year);

          }
          let trend_source_data = [];

          for (let i = ADTData.length; i-- > 0;) {
            trend_source_data[i] = [i, ADTData[i]]
          }
          let regression_data = fitData(trend_source_data).data
          let trend_line_data = [];
          for (let i = regression_data.length; i-- > 0;) {
            trend_line_data[i] = regression_data[i][1];
          }

          let trendArray = [];

          trend_line_data.map((trendValue, index) => {

            trendArray.push([datas[index][0], trendValue])
          })


          let tempData = findLineByLeastSquares(ADTYear, ADTData).reverse();
          //setEChartTrendLineData(tempData);
          result['eChartTrendLineData'] = tempData;

          let yearADT = ADTYear.map((i) => parseInt(i));

          //setEChartData(ADTData.reverse());
          result['eChartData'] = ADTData.reverse();

          //setEChartYear(yearADT.reverse());
          result['eChartYear'] = yearADT.reverse();

          //setchart(datas);
          result['etchart'] = datas;

          return result;

        }
        else {
          return []
        }

      })
    }
    catch (error) {
      
    }
  }